import React, { useState, useEffect, useMemo } from "react"
import parse from 'html-react-parser'
import { EditPenawaran } from './EditPenawaran'
import { DrafPKS } from './DrafPKS'
import { ViewPKS } from './ViewPKS'
import { PreviewPKS } from './PreviewPKS'
import { EditPKS } from './EditPKS'
import Pagination from '../../pages/paginations'
import ChatComponent from '../../chat/ChatComponent'
import axiosJWT from '../../JwtToken'

function MonitoringPengadaan() {

    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])
    const [rowID, setRowID] = useState(false)
    const [requestCode, setRequestCode] = useState(false)
    const [edit, setEdit] = useState(false)

    const [isPksOpen, setIsPksOpen] = useState(false)
    const [modalType, setModalType] = useState(null)

    const [showChatDrawer, setShowChatDrawer] = useState(false)
    const [activeRoomCode, setActiveRoomCode] = useState(null)
    const [activeVendorId, setActiveVendorId] = useState('')
    const [activeVendorName, setActiveVendorName] = useState('')
    const [isOpening, setIsOpening] = useState(false)

    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    useEffect(() => {
        getData('')
    }, [])

    const getData = async (key) => {
        try {
            const response = await axiosJWT.post("/api/request-procurement/load", {
                key: key,
                categoryPage: 'monitoring',
                jml: 100
            })
            setData(response.data)
            setCurrentPage(1)
        } catch (err) {
            getPesan()
            if (err.response && err.response.data && err.response.data.msg) {
                setMsg(err.response.data.msg)
            } else {
                setMsg('Data tidak terkirim, mohon coba lagi!')
            }
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const handleBatalkanPengajuan = async (id) => {
        try {
            const response = await axiosJWT.put(`/api/request-procurement/batal-vendor/${id}`)
            getPesan()
            setMsg("Pengajuan berhasil dibatalkan")
            getData('')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            getPesan()
            if (err.response && err.response.data && err.response.data.msg) {
                setMsg(err.response.data.msg)
            } else {
                setMsg('Gagal membatalkan pengajuan')
            }
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    const openEdit = async (id) => {
        setRowID(id)
        setEdit(true)
    }

    const closeEdit = () => {
        setRowID(null)
        setEdit(false)
    }

    const displayEdit = {
        display: `${edit ? "block" : "none"}`
    }

    const openPKS = (id, reqCode, type) => {
        setRowID(id)
        setRequestCode(reqCode)
        setModalType(type)
        setIsPksOpen(true)
    }

    const closePKS = () => {
        setRowID(null)
        setRequestCode(null)
        setModalType(null)
        setIsPksOpen(false)
    }

    const displayPKS = {
        display: `${isPksOpen ? "block" : "none"}`
    }

    const openChat = async (row) => {
        const targetId = row.createdPotensialBy || row.email

        if (!targetId) {
            getPesan()
            setMsg('ID Pengguna tidak valid!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
            return
        }

        setIsOpening(true)
        try {

            const response = await axiosJWT.post("/api/chat/room", {
                receiverPotensialCode: targetId,
                referenceCode: row.requestCode,
                referenceType: 'PROCUREMENT'
            })

            setActiveVendorId(targetId)
            setActiveRoomCode(response.data.roomCode)
            setActiveVendorName(row.requestTitle || row.profile)
            setShowChatDrawer(true)
        } catch (err) {
            getPesan()
            setMsg('Gagal membuka ruang chat!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } finally {
            setIsOpening(false)
        }
    }

    const openFile = (url) => {
        setFileUrl(url)
        setShowModalFile(true)
    }
    const [file, setFile] = useState(null)
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [selectedPksId, setSelectedPksId] = useState(null)
    const [isUploading, setIsUploading] = useState(false)

    const openUploadModal = (id) => {
        setSelectedPksId(id)
        setShowUploadModal(true)
    }

    const handleUploadPks = async (id) => {
        if (!file) return alert("Pilih file terlebih dahulu!")

        setIsUploading(true)
        const formData = new FormData()
        formData.append("file", file)

        try {
            await axiosJWT.put(`/api/pks/upload/${id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            })

            getPesan()
            setMsg('PKS berhasil diupload!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
            setShowUploadModal(false)
            getData() // Refresh tabel
        } catch (err) {
            getPesan()
            if (err.response && err.response.data && err.response.data.msg) {
                setMsg(err.response.data.msg)
            } else {
                setMsg('Gagal upload!')
            }
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } finally {
            setIsUploading(false)
        }
    };

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-12 col-xs-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Cari berdasarkan kode pengajuan atau judul pengadaan..."
                                    onChange={(e) => getData(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data table-striped table-hover">
                            <thead>
                                <tr className="purple">
                                    <th width={"5%"} className="text-center">No</th>
                                    <th width={"15%"} className="text-center">ID Pengajuan</th>
                                    <th width={"35%"}>Paket Pengadaan yang Diikuti</th>
                                    <th width={"15%"}>Data Perusahaan Anda</th>
                                    <th width={"15%"}>Status Kelulusan Berkas</th>
                                    <th width={"15%"} className="text-center">Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center p-4">Belum ada riwayat pengajuan penawaran.</td>
                                    </tr>
                                ) : (
                                    tableData.map((row, i) => (
                                        <tr key={row._id}>
                                            <td className="text-center">{(currentPage - 1) * PageSize + (i + 1)}</td>
                                            <td className="text-center font-bold text-purple">{row.code}</td>
                                            <td className="text-left">
                                                <span className="badge d-inline-block text-wrap badge-default mb-1">{row.requestFrom}</span>
                                                <h5 className="font-bold no-m mb-1">{row.requestTitle}</h5>
                                                {row.requestDescription ? <div className="text-muted small">{parse(row.requestDescription)}</div> : null}
                                            </td>
                                            <td className="text-left small">
                                                <strong className="text-purple">{row.profile}</strong><br />
                                                <i className="fa fa-map-marker"></i> {row.alamat} Kel. {row.kelurahan} Kec. {row.kecamatan}<br />
                                                <i className="fa fa-user"></i> {row.contactName}<br />
                                                <i className="fa fa-phone"></i> {row.phoneNumber}
                                            </td>
                                            <td className="text-left">
                                                {row.status === '0' && <span className="badge d-inline-block text-wrap badge-success"><i className="fa fa-spinner fa-spin"></i> Dalam Proses Evaluasi</span>}
                                                {row.status === '1' && <span className="badge d-inline-block text-wrap badge-warning"><i className="fa fa-refresh"></i> Perbaikan Dokumen</span>}
                                                {row.status === '2' && <span className="badge d-inline-block text-wrap badge-primary"><i className="fa fa-check-circle"></i> Penawaran Diterima</span>}
                                                {row.status === '3' && <span className="badge d-inline-block text-wrap badge-dark" style={{ backgroundColor: '#555' }}><i className="fa fa-ban"></i> Pengajuan Dibatalkan</span>}
                                                {row.status === '4' && <span className="badge d-inline-block text-wrap badge-danger"><i className="fa fa-times-circle"></i> Gugur / Belum Lolos</span>}
                                                {row.status === '5' && <span className="badge badge-info"><i className="fa fa-file-contract"></i> PKS Berjalan</span>}
                                                {row.status === '6' && <span className="badge badge-success"><i className="fa fa-check-double"></i> PKS Selesai</span>}

                                                {row.status === '5' && (
                                                    <div className="mt-1">
                                                        <span className={`badge ${row.statusPKS === 'Disetujui' ? 'badge-success' : row.statusPKS === 'Ditolak' ? 'badge-danger' : 'badge-warning'}`}>
                                                            Status PKS: {row.statusPKS}
                                                        </span>
                                                    </div>
                                                )}

                                                {(row.status === '1' || row.status === '4' || (row.status === '5' && row.statusPKS === 'Ditolak')) && row.notesAdmin && (<>
                                                    {row.information && row.information !== 'undefined' && (
                                                        <div className="small text-danger font-italic border-top mt-1 pt-1">
                                                            Info: {parse(row.information)}
                                                        </div>
                                                    )}
                                                    <div className="label label-danger p-2 mt-2 small mb-0" style={{ borderLeft: '4px solid #d9534f' }}>
                                                        <strong><i className="fa fa-exclamation-triangle"></i> Catatan Koreksi:</strong><br />
                                                        {parse(row.notesAdmin)}
                                                    </div>
                                                </>)}
                                            </td>
                                            <td className="text-center">
                                                {/* 1. Kondisi status 0 & 1 (Sedang diproses) */}
                                                {row.status === '0' || row.status === '1' ? (
                                                    <>
                                                        <div className="mb-1">
                                                            <span className={`badge ${row.status === '1' ? 'badge-warning' : 'badge-info'}`}>
                                                                {row.status === '1' ? 'Perlu Perbaikan' : 'Menunggu Verifikasi'}
                                                            </span>
                                                        </div>
                                                        <div className="btn-group-vertical no-m">
                                                            {row.status === '1' && (
                                                                <button type="button" className="btn btn-warning btn-raised btn-sm br-2 mb-1" onClick={() => openEdit(row._id)}>
                                                                    <i className="fa fa-edit"></i> Perbaiki
                                                                </button>
                                                            )}
                                                            <button type="button" className="btn btn-danger btn-raised btn-sm br-2" onClick={() => handleBatalkanPengajuan(row._id)}>
                                                                <i className="fa fa-times"></i> Batalkan
                                                            </button>
                                                        </div>
                                                        <button onClick={() => openChat(row)} className="btn btn-raised btn-info btn-sm br-2 mt-1">
                                                            {isOpening ? "Memproses..." : <><i className="fa fa-comments"></i> Diskusi</>}
                                                        </button>
                                                    </>
                                                ) : row.status === '2' ? (
                                                    /* 2. Kondisi status 2 (Diterima) - Munculkan tombol ke PKS */
                                                    <>
                                                        <span className="badge badge-primary mb-1"><i className="fa fa-check"></i> Siap PKS</span><br />
                                                        <button className="btn btn-success btn-raised btn-sm br-2" onClick={() => openPKS(row._id, row.requestCode, 'DRAFT')}>
                                                            <i className="fa fa-file-contract"></i> Buat Draf PKS
                                                        </button>
                                                        <button className="btn btn-success btn-raised btn-sm br-2" onClick={() => openUploadModal(row.pksID)}>
                                                            <i className="fa fa-upload"></i> PKS TTD & Materai
                                                        </button>
                                                    </>
                                                ) : row.status === '5' ? (
                                                    // Status 5: Kontrak sedang berjalan
                                                    <>
                                                        <button type="button" className="btn btn-raised btn-info btn-sm br-2 mb-1" onClick={() => openPKS(row.pksID, '', 'PREVIEW')}>
                                                            <i className="fa fa-eye"></i> Preview Draf
                                                        </button>

                                                        {row.statusPKS === 'Ditolak' ? (
                                                            <button className="btn btn-danger btn-raised btn-sm br-2" onClick={() => openPKS(row._id, '', 'EDIT')}>
                                                                <i className="fa fa-pencil"></i> Perbaiki Draf
                                                            </button>
                                                        ) : (
                                                            <button className="btn btn-info btn-raised btn-sm br-2" onClick={() => openPKS(row._id, '', 'VIEW')}>
                                                                <i className="fa fa-eye"></i> {row.statusPKS === 'Pengajuan' ? 'Lihat Draf' : 'Lihat PKS'}
                                                            </button>
                                                        )}
                                                    </>) : row.status === '6' ? (
                                                        // Status 6: Kontrak selesai
                                                        <>
                                                            <button type="button" className="btn btn-xs btn-raised btn-danger br-2 mb-1" onClick={() => openFile(row.pksFileSigned ? row.pksFileSigned : row.pksFile)}>
                                                                <i className="fa fa-file-pdf-o"></i> PKS
                                                            </button><br />
                                                            <span className="badge badge-success">
                                                                <i className="fa fa-check-double"></i> Kontrak Selesai
                                                            </span>
                                                        </>) : (
                                                    /* 3. Kondisi lain (Ditolak/Dibatalkan/dll) */
                                                    <span className="text-muted small">
                                                        <i className="fa fa-lock"></i> Terkunci
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="form-group mt-3">
                        <div className="row">
                            <div className="col-md-3 col-xs-6">
                                Ditemukan <b>{data.length}</b> Data Pengajuan
                            </div>
                            <div className="col-md-9 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12 col-xs-12">
                            <div className="bg-light p-3 br-2" style={{ borderLeft: '4px solid #d9534f', backgroundColor: '#fff5f5' }}>
                                <strong className="text-danger">
                                    <i className="fa fa-exclamation-triangle"></i> Informasi & Ketentuan Penting Pengajuan Penawaran:
                                </strong>
                                <br />
                                <small className="text-dark d-block mt-2">
                                    1. Dokumen penawaran dengan status <b>"Dalam Proses Evaluasi"</b>, <b>"Penawaran Diterima"</b>, atau <b>"Pengajuan Dibatalkan"</b> secara otomatis <b>DIKUNCI oleh sistem</b> dan tidak dapat diubah atau dihapus demi menjaga integritas serta transparansi proses audit pengadaan.
                                </small>
                                <small className="text-dark d-block mt-1">
                                    2. Apabila status berubah menjadi <b>"Perbaikan Dokumen"</b>, Anda diberikan kesempatan untuk memperbaiki dan mengunggah kembali dokumen hasil resmi atau membatalkan pengajuan sebelum batas akhir waktu pengadaan berakhir.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {edit ? (<>
            <div className={edit ? ("modal-open") : ("")}>
                <div style={displayEdit} className={edit ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Update Penawaran</h4>
                            </div>
                            <div className="modal-body">
                                <EditPenawaran getData={getData} rowID={rowID} closeEdit={closeEdit} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}

        {isPksOpen ? (<>
            <div className={isPksOpen ? ("modal-open") : ("")}>
                <div style={displayPKS} className={isPksOpen ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content modal-lg">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">PKS</h4>
                            </div>
                            <div className="modal-body">
                                {modalType === 'DRAFT' && <DrafPKS getData={getData} rowID={rowID} requestCode={requestCode} closePKS={closePKS} getPesan={getPesan} setMsg={setMsg} />}
                                {modalType === 'VIEW' && <ViewPKS rowID={rowID} closePKS={closePKS} />}
                                {modalType === 'EDIT' && <EditPKS getData={getData} rowID={rowID} closePKS={closePKS} getPesan={getPesan} setMsg={setMsg} />}
                                {modalType === 'PREVIEW' && <PreviewPKS rowID={rowID} getPesan={getPesan} closePKS={closePKS} setMsg={setMsg} />}
                            </div>
                            {/* <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setIsPksOpen(false)}>Tutup</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}

        {/* DRAWER CHAT ADMIN */}
        {showChatDrawer && (
            <>
                <div className={'chat-canvas'}>
                    <div className="bg-primary p-3 text-white d-flex justify-content-between">
                        <span>Diskusi: {activeVendorName}</span>
                        <button className="btn btn-raised btn-xs btn-danger" onClick={() => setShowChatDrawer(false)}>X</button>
                    </div>
                    <div style={{ height: 'calc(100% - 50px)' }}>
                        {/* PANGGIL KOMPONEN CHAT KITA DI SINI */}
                        <ChatComponent
                            roomCode={activeRoomCode}
                            targetUser={activeVendorId}
                        />
                    </div>
                </div>
                <div className="modal-backdrop fade in" onClick={() => setShowChatDrawer(false)} style={{ zIndex: 1069 }}></div>
            </>
        )}

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-md">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalFile(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview File</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}

        {showUploadModal ? (<>
            <div className={showUploadModal ? ("modal-open") : ("")}>
                <div style={{ display: showUploadModal ? 'block' : 'none' }} className={showUploadModal ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content modal-lg">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">PKS</h4>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-warning small text-dark">
                                    <i className="fa fa-info-circle"></i> Pastikan dokumen sudah ditandatangani, dibubuhi materai, dan discan dalam bentuk <b>PDF</b> (Max 50MB).
                                </div>
                                <input type="file" className="form-control" accept=".pdf" onChange={(e) => setFile(e.target.files[0])} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowUploadModal(false)}>Tutup</button>
                                <button className="btn btn-primary btn-raised br-2" disabled={isUploading} onClick={() => handleUploadPks(selectedPksId)}>
                                    {isUploading ? "Mengupload..." : "Upload & Kirim"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}

        <div className={pesan ? "modal-open" : ""}>
            <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold">PESAN</h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default MonitoringPengadaan